import { List } from '@dixa/lib-shared-habla';
import produce from 'immer';
import {
  ConversationSummaryLabel,
  MetaConversation,
} from 'lib-shared-legacy-types';
import type { SearchConversationHit } from 'lib-shared-types-api';

import ConversationSummaryHelper from 'app/utils/conversationSummaryHelper';
import { ConversationSummary } from 'components/conversation/components/conversationSummary/conversationSummary';
import { getReplyWindowExpiresOnFromConversation } from 'components/conversation/utils/getReplyWindowExpiresOnFromConversation';

interface ConversationPreviewHeadlineProps {
  readonly metaConversation: MetaConversation;
  highlights?: SearchConversationHit['_highlights'];
}

export const ConversationPreviewHeadline = ({
  metaConversation: metaConversationReadOnly,
  highlights,
}: ConversationPreviewHeadlineProps): JSX.Element => {
  const subject =
    metaConversationReadOnly?.conversation?.attributes?.subject || '';
  const highlightedTitleString = highlights?.subject?.[0] ?? subject;

  const metaConversation = produce(metaConversationReadOnly, (draft) => {
    if (!draft.conversation.attributes) {
      draft.conversation.attributes = {};
    }
    draft.conversation.attributes.subject = highlightedTitleString;
  });

  const conversation = metaConversation?.conversation;
  const CSHelper = new ConversationSummaryHelper(metaConversation);

  const replyWindowExpiresOn =
    getReplyWindowExpiresOnFromConversation(metaConversation);

  const csid = conversation?.id;

  return (
    <div className="conversation-headline-desc">
      <ConversationSummary
        replyWindowExpiresOn={replyWindowExpiresOn}
        conversationInfo={CSHelper.getConversationInfo()}
        conversationAttributes={metaConversation.conversation.attributes}
        labels={CSHelper.getLabels() as ConversationSummaryLabel}
        loading={csid ? false : true}
        dropdown={
          <List>
            {CSHelper.getInfoListLines().map((item, index) => (
              <List.KeyValue key={index} pair={item} withHoverEffect={false} />
            ))}
          </List>
        }
      />
    </div>
  );
};
